module.exports = "/assets/11ca2e05534fcc3d88bd87ef3bc1a032.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VY.png
// module id = 1943
// module chunks = 0